import { Input as BaseInput } from '@base-ui/react/input';
import { cva, type VariantProps } from 'class-variance-authority';
import { cn } from '../../lib/cn.ts';

const inputVariants = cva(
  'w-full font-medium outline-none placeholder:text-ink-muted disabled:opacity-40 aria-invalid:border-danger-line aria-invalid:bg-danger-fill/50',
  {
    variants: {
      variant: {
        quiet:
          'bg-fill-faint border border-transparent rounded-md text-ink transition focus:shadow-focus',
        bare: 'bg-transparent border-none',
      },
      /* Named fieldSize: the native input `size` attribute (number) already occupies `size` */
      fieldSize: {
        md: 'text-base px-3.25 py-2.75',
        lg: 'text-base px-4 py-3',
      },
    },
    compoundVariants: [
      {
        variant: 'bare',
        class: 'p-0',
      },
    ],
    defaultVariants: {
      variant: 'quiet',
      fieldSize: 'md',
    },
  },
);

type InputVariants = VariantProps<typeof inputVariants>;

interface InputProps extends Omit<BaseInput.Props, 'style' | 'className'>, InputVariants {
  className?: string;
  invalid?: boolean;
}

function Input({ className, variant, fieldSize, invalid, ...props }: InputProps) {
  return (
    <BaseInput
      data-slot='input'
      aria-invalid={invalid || undefined}
      className={cn(inputVariants({ variant, fieldSize }), className)}
      {...props}
    />
  );
}

export { Input, inputVariants, type InputProps, type InputVariants };
